/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Version_Gate_Update_MessageInputs */



/**
* | output |
* | --- |
* | "Ready for this feature? Request your update from our team via" |
*
* @param {Version_Gate_Update_MessageInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const version_gate_update_message = /** @type {((inputs?: Version_Gate_Update_MessageInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Version_Gate_Update_MessageInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ready for this feature? Request your update from our team via")
	return /** @type {LocalizedString} */ ("Prêt pour cette fonctionnalité ? Demandez votre mise à jour à notre équipe via")
});